module.exports = __webpack_public_path__ + "img/logoWhite.e84aa159.svg";